import { mergeDelete } from "utils/payload.utils";

export const initialState = {
  organization: null,
  isOrganizationLoading: false,
  otherContactList: [],
  teamList: [],
  organizationSystems: [],
  organizationSystemDependencies: [],
  locationList: [],
  personList: [],
  usersTeamsPaginated: [],
  organizationResources: [],
  defaultPlatformFiles: [],
};

export const actionTypes = {
  SET_ORGANIZATION: "SET_ORGANIZATION",
  SET_ORGANIZATION_LOADING: "SET_ORGANIZATION_LOADING",
  SET_OTHER_CONTACT_LIST: "SET_OTHER_CONTACT_LIST",
  SET_TEAM_LIST: "SET_TEAM_LIST",
  SET_ORG_SYSTEMS: "SET_ORG_SYSTEMS",
  SET_ORG_SYSTEM_DEPENDENCIES: "SET_ORG_SYSTEM_DEPENDENCIES",
  SET_LOCATION_LIST: "SET_LOCATION_LIST",
  SET_PERSONS: "SET_PERSONS",
  SET_USERS_TEAMS_PAGINATED: "SET_USERS_TEAMS_PAGINATED",
  SET_ORG_RESOURCES: "SET_ORG_RESOURCES",
  SET_DEFAULT_PLATFORM_FILES: "SET_DEFAULT_PLATFORM_FILES",
  UPDATE_CONTACT_INFORMATION: "UPDATE_CONTACT_INFORMATION",
  DELETE_ORG_SYSTEM: "DELETE_ORG_SYSTEM",
  DELETE_ORG_RESOURCE: "DELETE_ORG_RESOURCE",
};

export function reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_ORGANIZATION_LOADING:
      return {
        ...state,
        isOrganizationLoading: action.payload,
      };
    case actionTypes.SET_ORGANIZATION:
      return {
        ...state,
        organization: action.payload,
        isOrganizationLoading: false,
      };
    case actionTypes.SET_OTHER_CONTACT_LIST:
      return { ...state, otherContactList: action.payload };
    case actionTypes.SET_TEAM_LIST:
      return { ...state, teamList: action.payload };
    case actionTypes.SET_ORG_SYSTEMS:
      return { ...state, organizationSystems: action.payload };
    case actionTypes.SET_ORG_SYSTEM_DEPENDENCIES:
      return { ...state, organizationSystemDependencies: action.payload };
    case actionTypes.SET_LOCATION_LIST:
      return { ...state, locationList: action.payload };
    case actionTypes.SET_PERSONS:
      return { ...state, personList: action.payload };
    case actionTypes.SET_USERS_TEAMS_PAGINATED:
      return { ...state, usersTeamsPaginated: action.payload };
    case actionTypes.SET_ORG_RESOURCES:
      return { ...state, organizationResources: action.payload };
    case actionTypes.SET_DEFAULT_PLATFORM_FILES:
      return { ...state, defaultPlatformFiles: action.payload };

    case actionTypes.DELETE_ORG_SYSTEM:
      return {
        ...state,
        organizationSystems: mergeDelete(
          state.organizationSystems,
          action.payload,
          "organizationSystemId",
        ),
      };

    case actionTypes.DELETE_ORG_RESOURCE:
      return {
        ...state,
        organizationResources: mergeDelete(
          state.organizationResources,
          action.payload,
          "resourceId",
        ),
      };

    default:
      return state;
  }
}
